import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React, { Component, createRef } from 'react';
import Fade from './Fade';
import Main from './Main';
import Inner from './Inner';
import Wrap from './Wrap';
import ScrollAction from './ScrollAction';
import Content from './Content';

var HorizontalScroll = /*#__PURE__*/function (_Component) {
  _inheritsLoose(HorizontalScroll, _Component);

  function HorizontalScroll(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleScroll = function (e) {
      var start = e.target.scrollLeft === 0;
      var end = e.target.scrollWidth - e.target.scrollLeft === e.target.clientWidth;
      var _this$props = _this.props,
          scrollBtnWidth = _this$props.scrollBtnWidth,
          currentContentWidth = _this$props.currentContentWidth;
      var contentWidth = _this.state.contentWidth;

      _this.setState({
        scrollStart: start,
        scrollEnd: end,
        showEndButton: _this.checkEndButton(scrollBtnWidth, currentContentWidth || contentWidth)
      });
    };

    _this.handleScrollStart = function () {
      var scrollableBack = 0;

      if (_this.scrollableEl && _this.scrollableEl.current) {
        scrollableBack = -_this.scrollableEl.current.scrollLeft + _this.containerEl.current.scrollWidth / 1.5;

        _this.scrollableEl.current.scrollTo({
          top: 0,
          left: -scrollableBack,
          behavior: 'smooth'
        });
      }
    };

    _this.handleScrollEnd = function () {
      var scrollableForward = 0;

      if (_this.scrollableEl && _this.scrollableEl.current) {
        scrollableForward = _this.scrollableEl.current.scrollLeft + _this.containerEl.current.scrollWidth / 1.5;

        _this.scrollableEl.current.scrollTo({
          top: 0,
          left: scrollableForward,
          behavior: 'smooth'
        });
      }
    };

    _this.updateDimensions = function () {
      var _this$props2 = _this.props,
          scrollBtnWidth = _this$props2.scrollBtnWidth,
          currentContentWidth = _this$props2.currentContentWidth;
      var contentWidth = _this.state.contentWidth;

      if (_this.childWrapEl && _this.childWrapEl.current && _this.childWrapEl.current.firstChild) {
        _this.setState({
          showEndButton: _this.checkEndButton(scrollBtnWidth, currentContentWidth || contentWidth)
        });
      }
    };

    _this.handleWidthContainer = function () {
      _this.doReportSize = true;
    };

    _this.checkEndButton = function (scrollBtnWidth, contentWidth) {
      var containerLeft = _this.containerEl.current.getBoundingClientRect().left;

      var parentWidth = _this.childWrapEl.current.getBoundingClientRect().width;

      var childLeft = Math.floor(_this.childWrapEl.current.firstChild.getBoundingClientRect().left);
      var childWidth = Math.floor(_this.childWrapEl.current.firstChild.getBoundingClientRect().width);
      var childEnd = _this.childWrapEl.current.offsetWidth < _this.childWrapEl.current.firstChild.offsetWidth && parentWidth - childWidth + scrollBtnWidth < childLeft - containerLeft - 1 && contentWidth > parentWidth;
      return childEnd;
    };

    _this.containerEl = /*#__PURE__*/createRef();
    _this.scrollableEl = /*#__PURE__*/createRef();
    _this.childWrapEl = /*#__PURE__*/createRef();
    _this.contentWrapEl = /*#__PURE__*/createRef();
    _this.state = {
      scrollStart: true,
      scrollEnd: false,
      showEndButton: false,
      contentWidth: undefined
    };
    return _this;
  }

  var _proto = HorizontalScroll.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var scrollBtnWidth = this.props.scrollBtnWidth;

    if (this.contentWrapEl && this.contentWrapEl.current) {
      var initialContentWidth = this.contentWrapEl.current.getBoundingClientRect().width;
      this.setState({
        contentWidth: initialContentWidth,
        showEndButton: this.checkEndButton(scrollBtnWidth, initialContentWidth)
      });
    }

    window.addEventListener('resize', this.updateDimensions);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this$props3 = this.props,
        forceScrollTo = _this$props3.forceScrollTo,
        scrollBtnWidth = _this$props3.scrollBtnWidth,
        currentContentWidth = _this$props3.currentContentWidth;

    if (this.doReportSize) {
      var updatedContentWidth = this.contentWrapEl.current.getBoundingClientRect().width; // eslint-disable-next-line react/no-did-update-set-state

      this.setState({
        contentWidth: currentContentWidth,
        showEndButton: this.checkEndButton(scrollBtnWidth, currentContentWidth || updatedContentWidth)
      });
      this.doReportSize = false;
    }

    if (prevProps.currentContentWidth !== currentContentWidth) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        contentWidth: currentContentWidth,
        showEndButton: this.checkEndButton(scrollBtnWidth, currentContentWidth)
      });
    }

    if (prevProps.forceScrollTo !== forceScrollTo) {
      this.scrollableEl.current.scrollTo({
        top: 0,
        left: forceScrollTo,
        behavior: 'smooth'
      });
    }
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        fade = _this$props4.fade,
        fadeColor = _this$props4.fadeColor,
        fadeWidth = _this$props4.fadeWidth,
        scrollButton = _this$props4.scrollButton,
        scrollBtnWidth = _this$props4.scrollBtnWidth,
        scrollButtonColor = _this$props4.scrollButtonColor,
        scrollIconColor = _this$props4.scrollIconColor,
        scrollIconSize = _this$props4.scrollIconSize,
        forceScrollTo = _this$props4.forceScrollTo,
        children = _this$props4.children;
    var _this$state = this.state,
        scrollEnd = _this$state.scrollEnd,
        scrollStart = _this$state.scrollStart,
        showEndButton = _this$state.showEndButton;
    return /*#__PURE__*/React.createElement(Main, {
      scrollButton: scrollButton,
      btnWidth: scrollBtnWidth,
      ref: this.containerEl
    }, fade && !scrollStart && /*#__PURE__*/React.createElement(Fade, {
      showStart: true,
      fadeColor: fadeColor,
      fadeWidth: fadeWidth
    }), fade && !scrollEnd && /*#__PURE__*/React.createElement(Fade, {
      showEnd: true,
      fadeColor: fadeColor,
      fadeWidth: fadeWidth
    }), scrollButton && !scrollStart && /*#__PURE__*/React.createElement(ScrollAction, {
      showStart: true,
      btnWidth: scrollBtnWidth,
      handleClick: this.handleScrollStart,
      btnColor: scrollButtonColor,
      iconColor: scrollIconColor,
      iconSize: scrollIconSize
    }), scrollButton && showEndButton && /*#__PURE__*/React.createElement(ScrollAction, {
      showEnd: true,
      btnWidth: scrollBtnWidth,
      handleClick: this.handleScrollEnd,
      btnColor: scrollButtonColor,
      iconColor: scrollIconColor,
      iconSize: scrollIconSize
    }), /*#__PURE__*/React.createElement(Inner, {
      onScroll: this.handleScroll,
      ref: this.scrollableEl,
      forceScrollTo: forceScrollTo
    }, /*#__PURE__*/React.createElement(Wrap, {
      ref: this.childWrapEl
    }, /*#__PURE__*/React.createElement(Content, {
      ref: this.contentWrapEl,
      onChange: this.handleWidthContainer
    }, children))));
  };

  return HorizontalScroll;
}(Component);

HorizontalScroll.defaultProps = {
  fade: true,
  fadeColor: undefined,
  fadeWidth: undefined,
  scrollButton: false,
  scrollBtnWidth: 40,
  scrollButtonColor: undefined,
  scrollIconColor: undefined,
  scrollIconSize: undefined,
  forceScrollTo: 0,
  currentContentWidth: undefined
};
export default HorizontalScroll;